<template>
  <div class='modal'>
    <Button @click="modalBtn(msg,handleSelectData)">
      <Icon :type="icon" />{{msg}}
    </Button>
    <Modal
      v-if="msg != '字典分类'"
      v-model="modal1"
      @on-ok="ok(msg)"
      @on-cancel="cancel"
      :draggable="true"
    >
      <p slot="header">
        <span>{{msg}}字典</span>
      </p>
      <Form
        v-if="msg!='删除'"
        ref="formValidate"
        :model="formValidate"
        :rules="ruleValidate"
        :label-width="80"
      >
        <FormItem
          style="margin-bottom:22px"
          label="项目名"
          prop="detailname"
        >
          <Input
            v-model="formValidate.detailname"
            placeholder="请输入名称"
          ></Input>
        </FormItem>
        <FormItem
          style="margin-bottom:22px"
          label="项目值"
          prop="detailvalue"
        >
          <Input
            v-model="formValidate.detailvalue"
            placeholder="请输入编号"
          ></Input>
        </FormItem>
        <FormItem
          label="排序"
          prop="seqno"
        >
          <Input
            v-model="formValidate.seqno"
            placeholder="请输入编号"
          ></Input>
        </FormItem>
        <!-- <Checkbox
          v-model="formValidate.isenable"
          style="margin:0px 50px 20px 80px"
          @on-change="boxChange"
        >有效</Checkbox> -->
        <FormItem label="是否启用">
          <el-switch
            v-model="formValidate.isenable"
            active-text="启用"
            inactive-text="禁用"
            :active-value="1"
            :inactive-value="0">
          </el-switch>
        </FormItem>
        <FormItem
          label="备注"
          prop="description"
        >
          <Input
            v-model="formValidate.description"
            placeholder="请输入备注"
          ></Input>
        </FormItem>
      </Form>

      <p
        v-else
        style="text-align:center;font-size:20px"
      >
        <Icon
          style="font-size:30px;color:red"
          type="ios-alert-outline"
        />是否确认删除所选项
      </p>
    </Modal>
    <Modal
      v-else
      v-model="modal1"
      width="800"
      footer-hide
      :scrollable="true"
    >
      <p slot="header">
        <span>分类管理</span>
      </p>
      <div style="text-align:right;border-bottom:1px solid #ccc;padding-bottom:16px;">
        <Button @click="dictsortBtn('新增')">
          <Icon type="md-add" />新增
        </Button>
        <Button
          style="margin:0 10px"
          @click="dictsortBtn('编辑')"
        >
          <Icon type="ios-create" />编辑
        </Button>
        <Button @click="dictsortBtn('删除')">
          <Icon type="md-trash" />删除
        </Button>

      </div>
      <el-table
        ref="singleTable"
        :data="dictsortData"
        highlight-current-row
        @current-change="dictsortChange"
        style="width: 100%"
        row-key="itemid"
        :tree-props="{children: 'children', hasChildren: 'hasChildren'}"
      >
        >
        <el-table-column
          type="index"
          label="编号"
          width="50"
        >
        </el-table-column>
        <el-table-column
          property="itemname"
          label="名称"
          width="250"
        >
        </el-table-column>
        <el-table-column
          property="itemcode"
          label="编号"
        >
        </el-table-column>
        <el-table-column
          property="seqno"
          label="排序"
        >
        </el-table-column>
        <el-table-column
          property="isenable"
          label="有效"
        >
          <template slot-scope="scope">
            <el-switch
              :disabled="true"
              v-model="scope.row.isenable==1?scope.row.isenable=true:scope.row.isenable=false"
              active-color="#7ed6df"
              inactive-color="#ff7979"
            ></el-switch>
          </template>
        </el-table-column>
        <el-table-column
          property="description"
          label="备注"
        >
        </el-table-column>
      </el-table>
    </Modal>
    <el-dialog
      :visible.sync="dialogVisible"
      width="25%"
      :before-close="handleClose"
    >
      <span slot="title">
        {{title}}分类
      </span>
      <el-form
        v-if="this.title != '删除'"
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="100px"
        class="demo-ruleForm"
      >
        <el-form-item
          label="名称"
          prop="itemname"
        >
          <el-input v-model="ruleForm.itemname"></el-input>
        </el-form-item>
        <el-form-item
          label="编号"
          prop="itemcode"
        >
          <el-input v-model="ruleForm.itemcode"></el-input>
        </el-form-item>
        <el-form-item
          label="排序"
          prop="seqno"
        >
          <el-input v-model="ruleForm.seqno"></el-input>
        </el-form-item>
        <el-form-item label="是否启用">
          <el-switch
            v-model="ruleForm.isenable"
            active-text="启用"
            inactive-text="禁用"
            :active-value="1"
            :inactive-value="0">
          </el-switch>
        </el-form-item>
        <el-form-item
          label="备注"
          prop="description"
        >
          <el-input v-model="ruleForm.description"></el-input>
        </el-form-item>
        <el-form-item style="margin-left:170px">
          <el-button
            type="primary"
            @click="submitForm('ruleForm')"
          >确 定</el-button>
          <el-button @click="ruleFormCentel(title)">取 消</el-button>
        </el-form-item>
      </el-form>
      <p
        v-else
        style="text-align:center;font-size:20px"
      >
        <Icon
          style="font-size:30px;color:red"
          type="ios-alert-outline"
        />是否确认删除所选项
      <div style="text-align:right;margin-top:20px;">
        <span
          v-if="this.title == '删除'"
          slot="footer"
          class="dialog-footer"
        >
          <el-button @click="dialogVisible = false">取 消</el-button>
          <el-button
            type="primary"
            @click="DelDataItem"
          >确 定</el-button>
        </span>
      </div>
      </p>

      </span>
    </el-dialog>
  </div>
</template>
<script>
import Api from "../api/index";

export default {
  data() {
    return {
      modal1: false,
      dialogVisible: false,
      title: "",
      formValidate: {
        detailname: "",
        detailvalue: "",
        seqno: "",
        description: "",
        isenable: 1,
        itemid: "",
      },
      ruleValidate: {
        detailname: [
          { required: true, message: "项目名不能为空", trigger: "blur" },
        ],
        detailvalue: [
          { required: true, message: "项目值不能为空", trigger: "blur" },
        ],
        seqno: [
          { required: true, message: "排序编号不能为空", trigger: "blur" },
        ],
      },
      dictsortData: [],
      ruleForm: {
        parentId: 0,
        itemname: "",
        itemcode: "",
        seqno: null,
        isenable: 1,
        description: "",
      },
      rules: {
        itemname: [{ required: true, message: "请输入名称", trigger: "blur" }],
        itemcode: [{ required: true, message: "请输入编号", trigger: "blur" }],
        seqno: [{ required: true, message: "请输入排序", trigger: "blur" }],
      },
      selectdictsort: "",
    };
  },
  props: {
    msg: String,
    icon: String,
    handleSelectData: Object,
  },
  methods: {
    async modalBtn(msg, handleSelectData) {
      if (this.$store.state.itemid == "" && msg == "新增") {
        return this.$Message.info("请选择字典分类！");
      }
      if (msg == "字典分类") {
        const res = await Api.dictionary.getDataDictionary();
        this.dictsortData = res.rows;
      }
      this.modal1 = true;
      if (msg == "删除" || msg == "编辑") {
        if (handleSelectData == null) {
          this.$Message.info("您没有选中任何数据项,请选中后再操作！");
          this.modal1 = false;
        }
      }
      if (msg == "编辑") {
        const req = await Api.dictionary.GetDataItemDetailInfo(
          handleSelectData.itemdetailid
        );
        this.formValidate = req.rows;
        console.log(this.formValidate, "this.formValidate");
      }
    },
    async ok(value) {
      if (value == "删除") {
        const res = await Api.dictionary.DelDataItemDetail([
          this.handleSelectData.itemdetailid,
        ]);
        if (res.success != true) return this.$message.info(res.msg);
        this.$message.success(res.msg);
        return this.$router.go(0);
      }
      if (
        this.formValidate.detailname == "" ||
        this.formValidate.detailvalue == "" ||
        this.formValidate.seqno == ""
      ) {
        return this.$Message.info("请检查信息是否填写完整!");
      }
      if (value == "新增") {
        this.formValidate.itemId = this.$store.state.itemid;
        const res = await Api.dictionary.SaveDataItemDetail(this.formValidate);
        this.$Message.info(res.msg);
        this.$router.go(0);
      } else if (value == "编辑") {
        this.formValidate.itemId = this.$store.state.itemid;
        this.formValidate.itemDetailId = this.handleSelectData.itemdetailid;
        const res = await Api.dictionary.SaveDataItemDetail(this.formValidate);
        this.$Message.info(res.msg);
        this.$router.go(0);
      }
    },
    cancel() {},

    //复选框事件
    boxChange(e) {
      console.log(e,'444')
      // if (e) {
      //   this.formValidate.isenable = 1;
      // } else {
      //   this.formValidate.isenable = 0;
      // }
    },
    //字典分类选中事件
    dictsortChange(e) {
      this.selectdictsort = e;
    },
    handleNodeClick(data) {
      console.log(data);
    },
    //字典分类按钮
    async dictsortBtn(msg) {
      if (msg == "编辑" && this.selectdictsort == "") {
        return this.$Message.info("请选择编辑项！");
      } else if (msg == "编辑") {
        const res = await Api.dictionary.GetDataItemInfo(
          this.selectdictsort.itemid
        );
        if (!res.success) return;
        this.ruleForm = res.rows;
      }
      if (msg == "删除" && this.selectdictsort == "") {
        return this.$Message.info("请选择删除项！");
      }
      this.dialogVisible = true;
      this.title = msg;
    },
    handleClose(done) {
      if (this.title == "编辑") {
        this.ruleForm = {};
      }

      this.$confirm("确认关闭？")
        .then((_) => {
          done();
        })
        .catch((_) => {});
    },
    ruleFormCentel(e) {
      if (this.title == "编辑") {
        this.ruleForm = {};
      }
      this.dialogVisible = false;
    },
    dictsortcheckbox(e) {
      if (e) {
        this.ruleForm.isenable = 1;
      } else {
        this.ruleForm.isenable = 0;
      }
    },
    submitForm(formName) {
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          if (this.ruleForm.isenable == true) {
            this.ruleForm.isenable = "1";
          } else if (this.ruleForm.isenable == false) {
            this.ruleForm.isenable = "0";
          }
          if (!this.ruleForm.itemid || this.ruleForm.itemid == "") {
            this.ruleForm.parentId = this.selectdictsort.itemid;
          }
          const res = await Api.dictionary.SaveDataItem(this.ruleForm);
          if (res.success) {
            this.$Message.success("操作成功!");
            const req = await Api.dictionary.getDataDictionary();
            this.dictsortData = req.rows;
            this.dialogVisible = false;
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    //删除字典分类
    async DelDataItem() {
      const res = await Api.dictionary.DelDataItem([
        this.selectdictsort.itemid,
      ]);
      if (res.success) {
        const req = await Api.dictionary.getDataDictionary();
        this.dictsortData = req.rows;
        this.dialogVisible = false;
      }
    },
  },
};
</script>
<style lang='less' scoped>
.modal {
  display: inline-block;
  button {
    padding: 5px 10px;
    margin-left: 10px;
    text-align: center;
  }
}
</style>